import Vue from "vue"
import Vuex from "vuex"

import pathify from "vuex-pathify"
pathify.options.mapping = "simple"

import {
  make
} from "vuex-pathify"

import myConstructor from "./myConstructor"

// setup store
const staticState = {
  loading: null,
  sysDate: 0,
  sysTime:0,

  menuIs:0,
  menuName:"",
  isMobile:false,

  listsCC: [],
  statHseSelect: [],
}

const getDefaultState = () => ({
  stats: new myConstructor.stats,
})
// initial state
const state = Object.assign(staticState, getDefaultState())

const mutations = make.mutations(state)
const resetMutation = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
}
Object.assign(mutations, resetMutation);

const actions = make.actions(state)
const getters = make.getters(state);
// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({

  // use the plugin
  plugins: [
    pathify.plugin
  ],

  // store properties
  state,
  mutations,
  actions,
  getters
})